import { ReactNode } from 'react';
import { NudosGenericModal, NudosModalContent } from '../../NudosComponents';
import NudosConfirmActionModalContent from './NudosConfirmActionModalContent';
import './NudosConfirmActionModal.scss';

const NudosConfirmActionModal = ({
  modalTitle,
  modalText,
  firstButtonText,
  secondButtonText,
  firstButtonAction,
  secondButtonAction,
  isLoading,
  customHeight = '220px',
  customMarginTopContainerButtons,
  customStyleModalTitle
}: {
  modalTitle?: string;
  modalText: string | ReactNode;
  firstButtonText: string;
  secondButtonText: string;
  firstButtonAction: () => void;
  secondButtonAction: () => void;
  isLoading?: boolean;
  customHeight?: string;
  customMarginTopContainerButtons?: string;
  customStyleModalTitle?: React.CSSProperties;
}) => {
  return (
    <NudosGenericModal
      modalContent={
        <NudosModalContent
          customWidth="466px"
          customHeight={customHeight}
          excludeHeader
          componentSize="medium"
          CustomModalComponent={
            <NudosConfirmActionModalContent
              firstButtonAction={firstButtonAction}
              secondButtonAction={secondButtonAction}
              firstButtonText={firstButtonText}
              secondButtonText={secondButtonText}
              modalTitle={modalTitle}
              modalText={modalText}
              isLoading={isLoading}
              customHeight={customHeight}
              customMarginTopContainerButtons={customMarginTopContainerButtons}
              customStyleModalTitle={customStyleModalTitle}
            />
          }
        />
      }
    />
  );
};

export default NudosConfirmActionModal;
